"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.objParser = exports.camelcaseParser = void 0;

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var camelcaseParser = function camelcaseParser(str) {
  return str.replace(/_+(.)/g, function (match, chr) {
    return chr.toUpperCase();
  });
};

exports.camelcaseParser = camelcaseParser;

var objParser = function objParser(obj) {
  if (obj === null) {
    // parse null to undefined.
    // reason: To prevent api response has null,
    // null and undefined is different in JS but the same for logic.
    // The most important thing is we can give undefined a default value,
    // when we destrucing response.
    return undefined;
  } else if ((0, _typeof2["default"])(obj) !== 'object') {
    return obj;
  }

  var newObj = {};
  var keys = Object.keys(obj);
  keys.forEach(function (key) {
    var value = obj[key];
    var newKey = camelcaseParser(key);

    if (Array.isArray(value)) {
      newObj[newKey] = value.reduce(function (res, item) {
        return res.concat(objParser(item));
      }, []);
    } else {
      newObj[newKey] = objParser(value);
    }
  });
  return newObj;
};

exports.objParser = objParser;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@snapask/common-components/dist/utils/objCamelcaseParser.js
// module id = 112
// module chunks = 33